module.exports = __webpack_public_path__ + "img/ayuda-selector-geoprocesos.62954901.png";